var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/document-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 1.89944H7.33333C4.125 1.89944 2.75 3.73278 2.75 6.48278V15.6494C2.75 18.3994 4.125 20.2328 7.33333 20.2328H14.6667C17.875 20.2328 19.25 18.3994 19.25 15.6494V6.48278C19.25 3.73278 17.875 1.89944 14.6667 1.89944ZM7.33333 11.2953H11C11.3758 11.2953 11.6875 11.6069 11.6875 11.9828C11.6875 12.3586 11.3758 12.6703 11 12.6703H7.33333C6.9575 12.6703 6.64583 12.3586 6.64583 11.9828C6.64583 11.6069 6.9575 11.2953 7.33333 11.2953ZM14.6667 16.3369H7.33333C6.9575 16.3369 6.64583 16.0253 6.64583 15.6494C6.64583 15.2736 6.9575 14.9619 7.33333 14.9619H14.6667C15.0425 14.9619 15.3542 15.2736 15.3542 15.6494C15.3542 16.0253 15.0425 16.3369 14.6667 16.3369ZM16.9583 8.54528H15.125C13.7317 8.54528 12.6042 7.41778 12.6042 6.02444V4.19111C12.6042 3.81528 12.9158 3.50361 13.2917 3.50361C13.6675 3.50361 13.9792 3.81528 13.9792 4.19111V6.02444C13.9792 6.65694 14.4925 7.17028 15.125 7.17028H16.9583C17.3342 7.17028 17.6458 7.48194 17.6458 7.85778C17.6458 8.23361 17.3342 8.54528 16.9583 8.54528Z",
    fill: "#FCFCFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.39ba6aaa470beeb1ef545fc869a9adfd.svg";
export { ForwardRef as ReactComponent };